import PdfSection from "../../pdfBuilder/components/layout/PdfSection";
import PdfSectionTitle from "../../pdfBuilder/components/typography/PdfSectionTitle";
import PdfTextBlock from "../../pdfBuilder/components/typography/PdfTextBlock";
// import PdfTextBlock from "../../pdfBuilder/components/PdfTextBlock";
import PdfPageBrandedSubmission from "../../pdfBuilder/pages/PdfPageBrandedSubmission";

import PdfBuilderDataItemRow from "../../pdfBuilder/components/data/PdfBuilderDataItemRow";

const PdfPageLoanDetails = ({ formData }) => {
  return (
    <PdfPageBrandedSubmission
      pageNumber={"3 of 6"}
      pageTitle={"Loan Details"}
      submittedBy={`${formData.firstName} ${formData.lastName}`}
      submittedDate={formData?.submission_date}
    >
      <PdfSection>
        <PdfSectionTitle>Loan Information</PdfSectionTitle>

        <PdfBuilderDataItemRow
          label="Product Type:"
          value={formData.loanProductType}
        />
        <PdfBuilderDataItemRow
          label="Loan Purpose:"
          value={formData.loanPurpose}
        />
        <PdfBuilderDataItemRow
          label="Base Loan Amount:"
          type={"dollar"}
          value={formData.baseLoanAmount}
        />

        {formData.totalConstructionBudget && (
          <PdfBuilderDataItemRow
            label="Total Construction Budget:"
            type={"dollar"}
            value={formData.totalConstructionBudget}
          />
        )}

        <PdfBuilderDataItemRow
          label="Expected Closing Date:"
          type={"date"}
          value={formData.expectedClosingDate}
        />

        <PdfBuilderDataItemRow
          label="Working with Broker:"
          value={formData.brokerDeal ? "Yes" : "No"}
        />

        <PdfBuilderDataItemRow
          label="Property Count:"
          value={formData.subjectPropertyCount}
        />
      </PdfSection>

      <PdfSection>
        <PdfSectionTitle>Exit Strategy</PdfSectionTitle>
        <PdfTextBlock>{formData.exitStrategy}</PdfTextBlock>
      </PdfSection>
    </PdfPageBrandedSubmission>
  );
};

export default PdfPageLoanDetails;
